const PriceCalculator = {
    getDiscountedPrice(originalPrice, discounts) {
        let price = originalPrice;

        let percent = 0;
        discounts.forEach(x => percent += x.percent);

        if (percent > 0) {
            price = price - price * (percent / 100);
            //price = Math.round((price - price * (percent / 100)) / 50) * 50;
        }

        const sumDiscounts = discounts.filter(elem => elem.sum);
        sumDiscounts.forEach(x => price = price - x.sum);

        const customDiscounts = discounts.filter(elem => elem.customSum);
        customDiscounts.forEach(x => price = price - x.customSum);

        return price;
    },

    isPaidEnough(paidSum, coursePrice, part) {
        if (part === 0) {
            return paidSum > 0 || coursePrice === 0;
        }

        return paidSum >= coursePrice * part;
    }
};

export default PriceCalculator;